module.exports = __webpack_public_path__ + "img/6.3e57de0a.png";